import makeStyles from '@material-ui/styles/makeStyles';

const style = makeStyles(() => ({
    commonBtn: {
        '&.MuiButton-root': {
            color: '#fff',
            border: 0,
            borderRadius: 4,
            fontSize: 15,
            padding: '0 10px',
            textTransform: 'capitalize',
            background: '#53252f',
            lineHeight: '50px',
            minWidth: 'inherit',
            width: '100%',
            textDecoration: 'none',
            // '&:hover': {
            //     background: '#532550',
            //     color: '#fff',

            // }
        }
    },
    whatsUpBtn: {
        // maxWidth: 'maxContent',
        '&.MuiButton-root': {
            background: 'green',
            lineHeight: '50px',
            '&:hover': {
                background: 'darkgreen',

            }
        }
    },
    templateButton: {
        '&.MuiButton-root': {
            background: '#eee',
            color: '#aaa',
            '&:hover': {
                background: '#ddd',
                color: '#aaa',
            }
        }
    },
    templateButton1: {
        '&.MuiButton-root': {
            background: '#eee',
            color: '#53252f',
            '&:hover': {
                background: '#ddd',
                color: '#53252f',
                borderColor: '#04AA6D',

            }
        }
    },
    templateButton2: {
        '&.MuiButton-root': {
            background: '#eee',
            color: '#53252f',
            border: '1px solid #53252f'

        }
    },
    templateButton3: {
        '&.MuiButton-root': {
            background: '#eee',
            color: 'black',
            '&:hover': {
                background: '#ddd',
                color: '#53252f',
                borderColor: '#04AA6D',
                lineHeight: '50px',
                

            }
        }
    },

    fullWidth: {
        '&.MuiButton-root': {
            width: '100%',
            background: '#fff',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 4,
            minHeight: 56,
            fontSize: 40,
            color: 'black',
            '&:hover': {
                background: '#fff',
                color: '#aaa',
            }
        }
    },
    btnWithRedStatic: {
        '&.MuiButton-root': {
            color: '#fff',
            border: 0,
            borderRadius: 4,
            fontSize: 15,
            padding: '0 20px',
            textTransform: 'capitalize',
            background: '#53252f',
            lineHeight: '50px',
            minWidth: 90,
            width: '100%',
            '&:hover': {
                background: '#53252f',
                color: '#fff',
            }
        }
    },
    disabledBtnColor: {
        '&.MuiButton-root': {
            color: '#fff',
            border: 0,
            borderRadius: 4,
            fontSize: 15,
            padding: '0 20px',
            textTransform: 'capitalize',
            background: '#96636d',
            lineHeight: '50px',
            minWidth: 90,
            width: '100%',
            '&:hover': {
                background: '#96636d',
                color: '#fff',
            }
        }
    },
    shareDealButton: {
        '&.MuiButton-root': {
            color: '#53252f',
            fontSize: 15,
            background: '#fff',
            border: '1px solid #53252f',
            '&:hover': {
                background: '#53252f',
                color: '#fff',
            }
        }
    },
    icchukParties: {
        '&.MuiButton-root': {
            background: 'none',
            fontSize: '25px',
            color: 'black',
            '&:hover': {
                background: 'none',
                color: 'black',
            }
        }


    },
    kgQuinatalTon: {
        '&.MuiButton-root': {
            background: '#fff',
            fontSize: '15px',
            color: 'black',
            border: '1px solid #53252f',
            borderWidth: 1,
            '&:hover': {
                background: '#53252f',
                color: '#fff',
            }
        }


    },

    fixedButton: {
        '&.MuiButton-root': {
            background: '#fff',
            fontSize: '15px',
            color: '#53252f',
            border: '1px solid #53252f',
            borderWidth: 1,
            // '&:hover': {
            //     background: '#53252f',
            //     color: '#fff',
            // }
        }
    },
    ActiveButton: {
        '&.MuiButton-root': {
            background: '#53252f',
            fontSize: '15px',
            color: '#fff',
            border: '1px solid transparent',
            borderWidth: 1,
            // '&:hover': {
            //     background: '#53252f',
            //     color: '#fff',
            // }
        }
    },


}));

export default style;
